import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="border-t bg-background mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-6 text-sm text-muted-foreground">
            <Link
              to="/privacy-policy"
              className="hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/eula"
              className="hover:text-foreground transition-colors"
            >
              EULA
            </Link>
          </div>
          <div className="text-sm text-muted-foreground text-center md:text-right">
            © 2025 TS4U SAS – Cart Xray. All rights reserved / Tous droits
            réservés.
          </div>
        </div>
      </div>
    </footer>
  );
};
